import { z } from 'zod'
import { auditFieldsSchema, uuidSchema } from './common.ts'

/** ЄДРПОУ of a company (8 digits) or РНОКПП of a sole trader (10). */
export const EDRPOU = /^(\d{8}|\d{10})$/

export const sellerEntitySchema = z
  .object({
    id: uuidSchema,
    name: z.string().min(1),
    edrpou: z.string().nullable(),
    isActive: z.boolean(),
    isDefault: z.boolean(),
  })
  .extend(auditFieldsSchema.shape)

export type SellerEntity = z.infer<typeof sellerEntitySchema>

export const createSellerEntityInputSchema = z.strictObject({
  name: z.string().trim().min(1).max(200),
  edrpou: z.string().trim().regex(EDRPOU, 'ЄДРПОУ: 8 або 10 цифр').nullable().default(null),
  isDefault: z.boolean().optional().default(false),
})

export type CreateSellerEntityInput = z.infer<typeof createSellerEntityInputSchema>

export const updateSellerEntityInputSchema = z
  .strictObject({
    name: z.string().trim().min(1).max(200).optional(),
    edrpou: z.string().trim().regex(EDRPOU, 'ЄДРПОУ: 8 або 10 цифр').nullable().optional(),
    isDefault: z.boolean().optional(),
    isActive: z.boolean().optional(),
  })
  .refine((input) => Object.keys(input).length > 0, 'Вкажіть хоча б одну зміну')
  .refine(
    (input) => !(input.isDefault === true && input.isActive === false),
    'Компанія за замовчуванням має бути активною',
  )

export type UpdateSellerEntityInput = z.infer<typeof updateSellerEntityInputSchema>
